module.exports = __webpack_public_path__ + "media/bootstrap-icons/pin-angle-5394130c.svg";